/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_NotesInputs */



/**
* | output |
* | --- |
* | "( ♪ ) Music Notes..." |
*
* @param {Music_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes = /** @type {((inputs?: Music_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("( ♪ ) Notes de musique...")
	if (locale === "de") return /** @type {LocalizedString} */ ("( ♪ ) Musiknoten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("( ♪ ) Note musicali...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("( ♪ ) Музыкальные ноты...")
	if (locale === "es") return /** @type {LocalizedString} */ ("( ♪ ) Notas musicales...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（♪）音符……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("( ♪ ) 音符...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("( ♪ ) संगीत नोट्स...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("( ♪ ) Notas musicais...")
	return /** @type {LocalizedString} */ ("( ♪ ) Music Notes...")
});